export default [
  {'name': 'Electric / ev', 'icon': 'speed', 'url': 'electric', 'color': 'F5E6FD'},
  {'name': 'Sports', 'icon': 'sport', 'url': 'sports', 'color': 'E3F8FB'},
  {'name': 'Crypto', 'icon': 'crypto', 'url': 'crypto', 'color': 'FEE5E1'},
  {'name': 'Real estate', 'icon': 'real_estate', 'url': 'estate', 'color': 'E2E8FF'},
  {'name': 'Business', 'icon': 'business', 'url': 'business', 'color': 'FFEDB6'},
  {'name': 'Anime / disney', 'icon': 'disney', 'url': 'disney', 'color': 'F5D4D2'},
  {'name': 'Funny', 'icon': 'funny', 'url': 'funny', 'color': 'E9D1ED'},
  {'name': 'NSFW', 'icon': 'nsfw', 'url': 'nsfw', 'color': 'D5DBFB'},
  {'name': 'Diet/Fitness', 'icon': 'diet', 'url': 'diet', 'color': 'E2F3F5'},
  {'name': 'Political', 'icon': 'political', 'url': 'political', 'color': 'DAFCF9'},
  {'name': 'Jobs', 'icon': 'jobs', 'url': 'jobs', 'color': 'E3FAE4'},
  {'name': 'Religion', 'icon': 'pray', 'url': 'religion', 'color': 'F5F8D8'},
  {'name': 'Water sport', 'icon': 'water', 'url': 'water', 'color': 'DDC7BF'},
  {'name': 'Coffee / tea', 'icon': 'coffe', 'url': 'coffee', 'color': 'EAF8FF'},
  {'name': 'Guns', 'icon': 'guns', 'url': 'guns', 'color': 'FFF0D8'},
  {'name': 'Beer', 'icon': 'beer', 'url': 'beer', 'color': 'EBDCDC'},
  {'name': 'Military', 'icon': 'military', 'url': 'military', 'color': ''},
  {'name': 'Flowers', 'icon': 'flower', 'url': 'flowers', 'color': ''},
  {'name': 'Girly', 'icon': 'girl', 'url': 'girly', 'color': ''},
  {'name': 'Food', 'icon': 'food', 'url': 'food', 'color': ''},
  {'name': 'Motivation', 'icon': 'motivation', 'url': 'motivation', 'color': ''},
  {'name': 'Random', 'icon': 'random', 'url': 'random', 'color': ''},
  {'name': 'Nature', 'icon': 'nature', 'url': 'nature', 'color': ''},
  {'name': 'Tech', 'icon': 'tech', 'url': 'tech', 'color': ''},
  {'name': 'Gaming', 'icon': 'gaming', 'url': 'gaming', 'color': ''},
]